import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateCataloguesState from './catalogues';
import updateCatalogueTemplatesState from '../templates/state/catalogueTemplates';
import updateDatasetSettingsState from './datasetSettings';
import updateDatasetState from './dataset';

const handlers = {
  ...updateCataloguesState,
  ...updateCatalogueTemplatesState,
  ...updateDatasetSettingsState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
